import { useEffect, useState } from 'react';

export const isLocalDevelopment =
  typeof window !== 'undefined' && window.location && window.location.hostname === 'localhost';

export const API_PROD_URL = 'https://api.repsy.co';

export const API_DEV_URL = 'http://localhost:5006';

export const getApiURL = () => (isLocalDevelopment ? API_DEV_URL : API_PROD_URL);

// Cache the initial mobile check to avoid repeated DOM queries
let cachedIsMobile: boolean | null = null;

export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  if (cachedIsMobile === null) {
    cachedIsMobile = window.innerWidth < 1024;
  }
  return cachedIsMobile;
};

// React hook for responsive mobile detection with memoization
export const useMobileDevice = (): boolean => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < 1024;
  });

  useEffect(() => {
    // Use matchMedia for efficient resize detection
    const mediaQuery = window.matchMedia('(max-width: 1023px)');

    const handleChange = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches);
      cachedIsMobile = e.matches;
    };

    // Set initial value
    setIsMobile(mediaQuery.matches);
    cachedIsMobile = mediaQuery.matches;

    // Listen for changes
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return isMobile;
};
